module.exports = __webpack_public_path__ + "img/ic_video_default.4bcd661e.png";